import { useState, type FormEvent } from 'react';

import { ErroreApi } from '../api/client.ts';
import { dimenticaCongedo, leggiCongedo } from '../auth/congedo.ts';
import { useAutenticazione } from '../auth/contesto.tsx';
import { Marchio } from '../componenti/Marchio.tsx';

export function Accesso() {
  const { accedi } = useAutenticazione();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errore, setErrore] = useState<string | null>(null);
  const [inCorso, setInCorso] = useState(false);

  /*
   * Perché si è finiti qui, se non ci si è arrivati da soli.
   *
   * Il caso vero è il cambio password: chiude tutte le sessioni compresa
   * quella in corso, quindi al primo 401 il contesto riporta a questa
   * schermata **senza che nessuno l'abbia chiesto**. Senza una riga che lo
   * dica, sembra che l'applicazione sia caduta proprio mentre si cambiava la
   * password — cioè nel momento peggiore per farsi venire un dubbio.
   *
   * Si legge a ogni ridisegno e non si consuma: a cancellarlo è l'accesso
   * riuscito, qui sotto.
   */
  const congedo = leggiCongedo();

  async function invia(evento: FormEvent) {
    evento.preventDefault();
    setErrore(null);
    setInCorso(true);

    try {
      await accedi(email, password);
      // Si è rientrati: il motivo per cui si era usciti ha finito il suo
      // lavoro, e alla prossima uscita — magari volontaria — non deve
      // ricomparire come se fosse successo di nuovo.
      dimenticaCongedo();
    } catch (e) {
      // Il backend risponde lo stesso messaggio per email inesistente e
      // password errata: qui non si aggiunge nessun dettaglio in più, sarebbe
      // esattamente l'informazione che quella scelta voleva non dare.
      setErrore(
        e instanceof ErroreApi
          ? e.message
          : 'Impossibile contattare il server. Riprova fra qualche istante.',
      );
    } finally {
      setInCorso(false);
    }
  }

  return (
    <div className="accesso">
      <div className="accesso-riquadro">
        <div className="riga-marchio">
          <Marchio dimensione={18} />
          <span className="nome-marchio">FMSchedule</span>
        </div>

        <h1 className="accesso-titolo">Accedi al tuo account</h1>
        <p className="accesso-sottotitolo">Monitora le scadenze dell'azienda</p>

        {/* Sopra l'errore: non è un errore, ed è la prima cosa da leggere per
            chi non ha capito perché è tornato al login. */}
        {congedo !== null && (
          <div className="avviso-congedo" role="status">
            {congedo}
          </div>
        )}

        {errore !== null && (
          <div className="avviso-errore" role="alert">
            {errore}
          </div>
        )}

        <form onSubmit={invia}>
          <div className="campo">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="nome@azienda.it"
              autoComplete="username"
              required
              autoFocus
            />
          </div>

          <div className="campo">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>

          <button type="submit" className="bottone bottone-principale" disabled={inCorso}>
            {inCorso ? 'Accesso in corso…' : 'Accedi'}
          </button>
        </form>
      </div>
    </div>
  );
}
